if (!customElements.get('swiper-text-image-icon')) {
    customElements.define(
        'swiper-text-image-icon',
        class SwiperTextImageIcon extends HTMLElement {
            constructor() {
                super();
                this.swiperInstance = null;
                this.swiperEl = this.querySelector('.swiper');
                this.items = this.querySelectorAll('.swiper-text-image-icon_content-item');
            }

            connectedCallback() {
                this.initSwiper();
                this.checkDevice();
            }

            initSwiper() {
                if (this.swiperEl) {
                    const pagination = this.querySelector('.swiper-pagination');
                    const self = this;

                    this.swiperInstance = new Swiper(this.swiperEl, {
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true,
                        },
                        pagination: {
                            el: pagination,
                            clickable: true,
                        },
                        on: {
                            slideChange: function () {
                                const activeItem = self.items[this.activeIndex];
                                if (activeItem) {
                                    activeItem.click();
                                }
                            },
                        },
                    });
                }
            }

            checkDevice() {
                let el = null;
                if (window.innerWidth > 1001) {
                    el = '.swiper-text-image-icon_content-item_content-text';
                } else {
                    el = '.swiper-text-image-icon_content-item_content';
                }
                this.hideEl(el);
                this.clickEl(el);
            }

            hideEl(selector) {
                const elements = this.querySelectorAll(selector);
                elements.forEach((el, index) => {
                    if (index > 0) {
                        el.style.display = 'none';
                    }
                });
            }

            clickEl(selector) {
                this.items.forEach((el) => {
                    el.addEventListener('click', () => {
                        if (el.classList.contains('active')) return;
                        // 所有el移除active
                        this.items.forEach((el) => {
                            el.classList.remove('active');
                        })
                        // 当前el添加active
                        el.classList.add('active');
                        this.swiperInstance.slideTo(el.dataset.index);
                        // 使用Jquery实现动画效果
                        $(selector).slideUp();
                        const $selector = $(el).find(selector);
                        $selector.slideDown();
                    });
                })
            }

            disconnectedCallback() {
            }
        }
    );
}
